import 'jquery-knob/js/jquery.knob'
import 'jquery-cookie/jquery.cookie'
let AtlasThumbsPlayer = require('atlas/AtlasThumbsPlayer')

window.spinnerTracking = null;
window.spinnerTracked = false;
window.spinnerLoaded = false;
var fadeTiming = {
  fadeIn: 500,
  fadeOut: 100,
  fadeOutClickAndDrag: 100
};
window.lastView = null;
window.lastViewAvailableFormats = null;
window.lastViewType = null;
window.updateUrlTimer = null;

if (!window.parsedAsset) {
  window.parsedAsset = JSON.parse(gon.asset);
}

function updateImageUrl() {
  if (window.updateUrlTimer) {
    clearTimeout(window.updateUrlTimer);
  }

  window.updateUrlTimer = setTimeout(function() {
    if (window.product) {
      window.product.pushState();
    }
  }, 500);

  //if we are iframed, this will post a message that the parent can receive
  var data = {
    message: 'imageChanged',
    view: window.lastView,
    type: window.lastViewType,
    availableFormats: window.lastViewAvailableFormats
  };

  $(document).trigger(data.message, data);
}

function imageChanged(type, view) {
  if (type === 'atlas') {
    if (!window.spinnerTracking) {
      window.spinnerTracking = view;
    }

    if (!window.spinnerLoaded) {
      ga_product_spinner_event('loaded');
      window.spinnerLoaded = true;
    }

    if (!window.spinnerTracked && (window.spinnerTracking !== view)) {
      $('.object-caption').fadeOut(fadeTiming.fadeOutClickAndDrag, function() {
        $('.product-imagery').addClass('bordered');
        $('.mobile-panel-space').animate({ marginTop: '35px' }, 1000);
      });
      ga_product_spinner_event('spun');
      window.spinnerTracked = true;
    }

    if (window.spinnerLoaded) {
      updateImageUrl();
    }
  }

  var availableFormats = player.getPlayer().getDownloadFormatsForView(view);

  if (window.product) {
    if (window.lastView !== view) {
      window.lastView = view;
      window.lastViewAvailableFormats = availableFormats;
      window.lastViewType = type;
      window.product.setCurrentView(view);
    }
  }
}

function getPlayerSize() {
  var productColumn = $('.product-main-column');
  var gutter = parseInt(productColumn.css('padding-left'));
  gutter += parseInt(productColumn.css('padding-right'));
  gutter += 2; // border
  var columnWidth = parseInt($('.product-main-column').css('width'));

  var playerSize = columnWidth - gutter;
  playerSize = Math.min(playerSize, 600);

  return playerSize;
}

function onResize() {
  var playerSize = getPlayerSize();

  $('.atlas').css('width', playerSize);
  $('.atlas').css('height', playerSize);

  if (window.player) {
    window.player.resizeWindow(playerSize);
  }
}

function initializeAtlasThumbsPlayer() {
  if ($(".products-show, .products-spinner, .photoshop_plugins-index").length === 0) {
    return;
  }

  var startingImage = null;
  if (gon.startingImage) {
    startingImage = {
      type: 'atlas',
      view: gon.startingImage
    }
  }

  var interactivityEnabled = false;
  var startTime = new Date();

  var assetId = gon.productId;
  if (typeof ga !== 'undefined') {
    ga('set', 'dimension1', assetId);
  }

  var options = {
    // optional
    onAfterImageChanged: function(oldView, newView) {
      imageChanged('atlas', newView);
    },
    onLoadingStarted: function(assetId) {
      $('.dial').val(0).trigger('change');

      //display the loading tip the first time the user views a spinner, use default
      //behavior otherwise
      if ($.cookie('first-spinner-load') != '0') {
        $.cookie('first-spinner-load', '0', { expires: 365, path: '/; SameSite=Lax', secure: true });
        $('.tooltip').fadeIn(fadeTiming.fadeIn);
        displayingTip = true;
      }

      if (typeof ga !== 'undefined') {
        var miliseconds = (new Date()) - startTime;
        ga('set', 'dimension1', assetId);
        ga('set', 'metric1', miliseconds);
        ga('send', 'event', 'player', 'loaded', { 'nonInteraction': true });
        ga('set', 'metric1', 0);
      }

      var data = {
        message: 'loadAsset',
        assetId: options.assetId,
        view: startingImage.view
      };
      $(document).trigger(data.message, data);
    },
    onLoadingCompleted: function(assetId) {
      $('.spinner-progress').fadeOut(fadeTiming.fadeOut);
      $('.spinner-progress-tip-area').hide();

      if (displayingTip) {
        $('.tooltip').fadeOut(fadeTiming.fadeIn);
        displayingTip = false;
      }

      var data = {
        message: 'onLoadingComplete',
        assetId: assetId
      };
      $(document).trigger(data.message, data);
    },
    onInteractivityEnabled: function() {
      $('.dial').val(0).trigger('change');
      $('.spinner-progress').removeClass('single-latitude').addClass('multi-latitude');
      $('.click-drag-tooltip').fadeIn(fadeTiming.fadeIn);

      interactivityEnabled = true;

      if (typeof ga !== 'undefined') {
        var miliseconds = (new Date()) - startTime;
        ga('set', 'metric2', miliseconds);
        ga_product_spinner_event('interactivity');
        ga('set', 'metric2', 0);
      }
    },
    onProgress: function(p) {
      if (!interactivityEnabled) {
        $('.dial').val(p.interactivityPercentage * 100.0).trigger('change');
      }
      else {
        $('.tooltip.hero').html('Loading all camera angles');
        $('.dial').val(p.imagePercentage * 100.0).trigger('change');
      }

      //if we are iframed, this will post a message that the parent can receive
      var data = {
        message: 'onProgress',
        assetId: assetId,
        interactivityEnabled: interactivityEnabled,
        interactivityPercentage: p.interactivityPercentage,
        imagePercentage: p.imagePercentage
      };
      $(document).trigger(data.message, data);
    },
    onThumbnailClicked: function(view, tag) {
      if (view) {
        if (interactivityEnabled) {
          var view = window.player.getPlayer().getCurrentImageIndex();
          imageChanged('atlas', view);
        }
        else {
          imageChanged('atlas', gon.initialView);
          $('.loading-progress').show();
        }

        if (typeof ga !== 'undefined') {
          ga('set', 'dimension2', view);
          ga('send', 'event', 'thumbnail', 'click');
          ga('set', 'dimension2', null);
        }
      }
    },
    showLoadingSequenceTip: function(state) {
    },
    configurationUrl: '/hero_config',
    asset: window.parsedAsset,
    assetId: assetId,
    startingImage: startingImage,
    displayingThumbnails: false,
    priorityImages: gon.priorityImages,
    thumbnailClickIsDrag: false,
    initialView: gon.initialView,
    alwaysSendLoadingSequenceEvents: true,
    thumbnailClassSelector: '.thumbnail-carousel-inner .thumbnail-outer',
    thumbnailStripClassSelector: '.thumbnail-carousel',
    thumbnailSelectedClass: 'selected-border',
    thumbnailRotatesViewer: false,
    capabilities: {
      windowDimensions: {
        width: gon.windowWidth || 600,
        height: gon.windowHeight || 600
      }
    }
  };

  var windowSize = getPlayerSize();
  options.capabilities.windowDimensions.width = windowSize;
  options.capabilities.windowDimensions.height = windowSize;

  function loadPlayer() {
    window.player = new AtlasThumbsPlayer(options, function() {
      if (gon.signatureImageType === "atlas") {
        player.displayViewer(gon.initialView, true);
        imageChanged('atlas', gon.initialView);
      }
    });
  }

  //1200px resolution images will be loaded by default if they are available
  //if we have a non-hdpi screen, but the 1200px images are loaded then reload
  //the asset with the 600px version
  if ((!Modernizr.hdpi) && (gon.signatureImageUrl.indexOf("jpeg-1200") > -1)) {
    $.ajax({
      url: gon.productId + '/spinner_product?resolution=600'
    }).success(function(data, status) {
      gon.asset = data;
      options.asset = data;
      loadPlayer();
    }).error(function(data, status) {
      loadPlayer();
    });
  } else {
    loadPlayer();
  }

  var displayingTip = false;

  $('.spinner-progress-tip-area').bind({
    mouseover: function() {
      if (!displayingTip) {
        $('.tooltip').fadeIn(fadeTiming.fadeIn);
        displayingTip = true;
      }
    },
    mouseout: function() {
      if (displayingTip) {
        $('.tooltip').fadeOut(fadeTiming.fadeIn);
        displayingTip = false;
      }
    }
  });

  $('.product-imagery').on("contextmenu", function(e) {
    return false;
  });
}

$(function() {
  var productImagery = $('.product-imagery');
  if (!productImagery || !productImagery.length) {
    return;
  }

  //set the initial size of the window
  onResize();

  $(window).on('resize', function() {
    //call when window resizes
    onResize();
  });

  $('#controlArea').on('mouseup', function() {
    //on spinner objects we need to wait until mouse up
    updateImageUrl();
  });

  $(".dial").knob();
  $('.loading-progress').show();

  ga_product_loaded('spinner only');
  initializeAtlasThumbsPlayer();
});
